import { Fragment, CSSProperties } from "react";
import { CircularProgress } from "@mui/material";
import { Checkmark } from "./Icons";

export type SaveState = "idle" | "saving" | "saved";

export interface SaveSpinnerProps {
  state: SaveState;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

const SaveSpinner = (props: SaveSpinnerProps) => {
  const { state } = props;

  const size = props.size || 12;

  return (
    <Fragment>
      {state === "idle" ? null : (
        <div className={props.className} style={props.style}>
          {state === "saving" ? <CircularProgress size={size} variant="indeterminate" /> : <Checkmark size={size} />}
        </div>
      )}
    </Fragment>
  );
};

export default SaveSpinner;
